.splash {
  display: grid;
  place-items: center;
  align-content: center;
  gap: var(--space-4);
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--bg-canvas);
  color: var(--text-tertiary);
}

.mark {
  object-fit: contain;
  width: 44px;
  height: 44px;
  filter: invert(1);
}

:global(:root[data-theme='light']) .mark {
  filter: none;
}

.label {
  font-size: var(--text-sm);
  letter-spacing: var(--tracking-wide);
}
